import * as React from "react"

import { cn } from "@common/lib/utils"
import { CONTROL_SURFACE, type ControlSize, controlSize } from "./control"

export const INPUT_FOCUS =
  "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2"

const Input = React.forwardRef<
  HTMLInputElement,
  Omit<React.ComponentProps<"input">, "size"> & { size?: ControlSize }
>(({ className, type, size, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex py-1 file:border-0 file:bg-transparent file:text-small-medium file:text-foreground placeholder:text-muted-foreground",
        controlSize({ size }),
        CONTROL_SURFACE,
        INPUT_FOCUS,
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }
